<template>
    <div>
        <el-dialog align-center v-model="state.dialogVisible" :title="dialogTitle" width="800" draggable>
            <!-- 人员基本信息 -->
            <div class="userAdd_man">
                <el-form ref="ruleForm" label-width="auto" :model="state.form" :rules="rules" class="userFrom">
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('deviceTemplate.templateName')" prop="title">
                            <el-input v-model="state.form.title" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" style="margin-bottom: 20px;">
                        <el-form-item :label="t('deviceTemplate.templateIntro')" prop="name">
							<el-input
							      v-model="state.form.name"
							      type="textarea"
							      :rows="2"
							      :placeholder="t('common.pleaseInput')"
							    ></el-input>

                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="state.dialogVisible = false">{{ t('common.cancel') }}</el-button>
                    <el-button type="primary" @click="submit">
                        {{ t('common.confirm') }}
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import {
    onMounted,
    reactive,
    ref,
    nextTick,
    defineEmits,
    defineProps,
    defineExpose,
    toRaw,
    computed,
} from "vue";
import { ElMessage } from "element-plus";
import { saveApi, detailApi } from "@/api/system/template";
import { usePageI18n } from '@/composables/usePageI18n.js';

const emit = defineEmits([]);
const props = defineProps({
    title: {
        type: String,
        default: "",
    },
});
const rules = reactive({
    title: [{ required: true, message: "", trigger: "blur" }],
    name: [{ required: true, message: "", trigger: "blur" }],
    model: [{ required: true, message: "", trigger: "blur" }],
});

const applyLabels = () => {
    if (rules?.title?.[0]) rules.title[0].message = t('common.pleaseInput') + t('deviceTemplate.templateName');
    if (rules?.name?.[0]) rules.name[0].message = t('common.pleaseInput') + t('deviceTemplate.templateIntro');
    if (rules?.model?.[0]) rules.model[0].message = t('common.pleaseInput') + t('field.model');
};
const { t } = usePageI18n(applyLabels);

const dialogTitle = computed(() => props.title || `${t('common.add')}${t('menu.deviceTemplate')}`);

const state = reactive({
    dialogVisible: false,
    form: {
        "id": 0,
        "title": "",
        "name": "",
        "model": "",
    }
});

const getTemplateInfo = (row = {}) => {
    if (row?.id) {
        const params = JSON.stringify({
            "id": row.id
        })
        detailApi(params).then(res => {
            if (res?.code !== 200) return
            state.form = {
                ...res.data,
            }
        })
    } else {
        state.form.id = 0
    }

}

const open = (row) => {
    getTemplateInfo(row)
    state.dialogVisible = true;
};

const ruleForm = ref(null)
const submit = () => {
    ruleForm.value.validate((valid) => {
        if (valid) {
            const params = JSON.stringify(toRaw(state.form))
            saveApi(params).then(res => {
                if (res?.code === 200) {
                    ElMessage.success(t('common.success'))
                    state.dialogVisible = false
                    state.form = {
                        "id": 0,
                        "title": "",
                        "name": "",
                        "model": "",
                    }
                    emit('refresh')
                }
            })
        } else {
            return false;
        }
    });
};

onMounted(() => {
    applyLabels();
});

defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man {
    min-height: 200px;
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;
}

.userFrom {
    display: flex;
    flex-wrap: wrap;
    /* 可选，添加网格项之间的间隙 */
    // grid-template-columns: repeat(2, 1fr);
}

.el-form-item {
    margin-bottom: 0;
}

.tree_man {
    padding: 0 30px;
}
</style>
